import React, { Component } from 'react';
import {Layout, Row } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { getUser } from 'actions/asyncActions';
import BackButton from 'components/common/elements/BackButton';
import Breakpoint from 'components/layout/Breakpoint.js';
import ProjectForm from './ProjectForm';
import { AddapplicationWithCreateProject } from '../application/AddapplicationWithCreateProject';
@withAsyncActions({
    getUser,
})
export default class ProjectAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            project_id: ""
        }
    }

    getProjectId = (id) => this.setState({project_id: id})
    
    
    render() {
        const { project_id } = this.state
        const { data: { user } } = this.props.getUser;

        return (
            <Layout className="project container page page-sm-no-m main-content">
                <Breakpoint min="sm">
                    <Row type="flex" align="middle" className="m-b-30">
                        <BackButton />
                        <span className="title-route m-l-30">
                            Cоздать проект
                        </span>
                    </Row>
                </Breakpoint>
                <Breakpoint max="sm">
                    <Row className="m-b-30 m-l-20">
                        <BackButton />
                        <div className="title-route m-t-10">
                            Cоздать проект
                        </div>
                    </Row>
                </Breakpoint>
                <ProjectForm 
                    history={this.props.history} 
                    getProjectId={this.getProjectId}
                    project_id={project_id}
                />

                <AddapplicationWithCreateProject 
                    user={user} 
                    project_id={project_id} 
                    history={this.props.history} 
                    getProjectId={this.getProjectId}
                />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/project/ProjectAdd.js